import React from "react";
import classNames from "classnames";
import { PodcastEpisodeColumn } from "./PodcastEpisodeColumn";
import Callout from "components/heroSection/Callout";
import { PODCAST_COLUMNS } from "./constants";
import HomePageSectionHeader from "components/homePageSectionHeader/homePageSectionHeader";
import type { PodcastEpisodesSectionProps } from "./types";

export const PodcastEpisodesSection: React.FC<PodcastEpisodesSectionProps> = ({
  latestEpisodes,
  topEpisodes,
  podcastCallout,
  sectionTitle,
  seeAllText,
  seeAllUrl,
  onSeeAllClick,
  onCalloutClick,
  calloutHref,
  className,
}) => {
  return (
    <div
      className={classNames("flex w-full flex-col gap-10", className)}
      data-testid="podcast-episodes-section"
    >
      <div className="flex w-full flex-col gap-4">
        <HomePageSectionHeader
          title={sectionTitle}
          buttonText={seeAllText}
          buttonUrl={seeAllUrl}
          onButtonClick={onSeeAllClick}
          className="h-[53px] justify-center pb-0 pt-4"
        />

        <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 md:gap-y-4 mdDesktop:grid-cols-2 mdDesktop:gap-y-4">
          <PodcastEpisodeColumn
            columnType={PODCAST_COLUMNS.LATEST}
            episodes={latestEpisodes}
          />

          <PodcastEpisodeColumn
            columnType={PODCAST_COLUMNS.TOP}
            episodes={topEpisodes}
          />
        </div>
      </div>

      {podcastCallout && (
        <Callout
          callout={podcastCallout}
          href={calloutHref}
          onClick={onCalloutClick}
          renderMarkdown
          titleSize="large"
        />
      )}
    </div>
  );
};

PodcastEpisodesSection.displayName = "PodcastEpisodesSection";

export default PodcastEpisodesSection;
